import Axios from 'axios';
import header from './auth/header';

const API_URL_V3 = process.env.API_URL + '/api/v3/'

class TabunganProduct {
  index(params) {
    let url = new URLSearchParams(params).toString();
    return Axios.get(`${API_URL_V3}product/funder?search_category=Tabungan&${url}`);
  }
  
}

export default new TabunganProduct();



// WEBPACK FOOTER //
// ./src/api/tabunganProduct.js